import { render, staticRenderFns } from "./BackgroundJob.vue?vue&type=template&id=2a5d4224&scoped=true"
import script from "./BackgroundJob.vue?vue&type=script&lang=js"
export * from "./BackgroundJob.vue?vue&type=script&lang=js"
import style0 from "./BackgroundJob.vue?vue&type=style&index=0&id=2a5d4224&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a5d4224",
  null
  
)

export default component.exports